// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6897) return "static/chunks/6897-540f694e135d5b05.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","8341":"b9b26c3f","9983":"profiler"}[chunkId] || chunkId) + "." + {"2973":"919505a6349fb5ee","3631":"c6981f7f9abe76a2","6274":"284ddb85a4df0d1c","7538":"7442eac445f5cadb","7792":"1078dbb5366087b4","8029":"32495ca6b0e7c5f8","8341":"44d705732ff6906d","9983":"10d42bc195628b91"}[chunkId] + ".js";
};